<template>
  <el-col :lg="span" :md="span" :sm="24" :xl="span" :xs="24">
    <div class="right-panel">
      <slot />
    </div>
  </el-col>
</template>

<script>
  export default {
    name: 'VabBoxAreaRightPanel',
    props: {
      span: {
        type: Number,
        default: 10,
      },
    },
  }
</script>
